module.exports = __webpack_public_path__ + "static/media/app3.085524b9.png";